import {
  getWebhookList,
  getWebhookRecordList,
  getWebhookDetail,
  DelWebhook,
  getWebhookRecordDetail,
  sendRecordAgain,
  addEditWebhook,
  getInitJsonData,
  getVarData,
  validForm,
  getRelateDevpDatas,
  setStopUsing
} from '@/services/config'
import i18n from '@/lib/language'

export default {
  namespaced: true,
  state: {
    listColumns: [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        slots: { title: 'name' },
        scopedSlots: { customRender: 'name' },
        width: 252
      },
      {
        title: i18n.t('message["587"]'),
        dataIndex: 'type',
        key: 'type',
        slots: { title: 'type' },
        scopedSlots: { customRender: 'type' },
        width: 160,
        ellipsis: true
      },
      {
        title: i18n.t('message["214"]'),
        dataIndex: 'path',
        key: 'path',
        slots: { title: 'address' },
        scopedSlots: { customRender: 'address' },
        width: '45%',
        ellipsis: true
      },
      {
        title: i18n.t('message["79"]'),
        dataIndex: 'hookid',
        key: 'hookid',
        slots: { title: 'hookid' },
        scopedSlots: { customRender: 'operate' }
      }
    ],
    sendListColumns: [
      {
        title: '发生时间',
        dataIndex: 'uptime',
        key: 'uptime',
        slots: { title: 'uptime' },
        scopedSlots: { customRender: 'uptime' },
        width: 224,
        sorter: true
      },
      {
        title: i18n.t('message["1646"]'),
        dataIndex: 'status',
        key: 'status',
        slots: { title: 'status' },
        scopedSlots: {
          filterIcon: 'filterIcon',
          filterDropdown: 'filterDropdown',
          customRender: 'status'
        },
        // filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test19"></i></em>,
        ellipsis: true
      },
      {
        title: '触发事件',
        dataIndex: 'event_name',
        key: 'event_name',
        slots: { title: 'event_name' },
        scopedSlots: { customRender: 'event_name' }
      },
      {
        title: '相关星轨信息',
        dataIndex: 'inquiry_code',
        key: 'inquiry_code',
        slots: { title: 'inquiry_code' },
        scopedSlots: { customRender: 'inquiry_code' }
      },
      {
        title: i18n.t('message["79"]'),
        dataIndex: 'recordid',
        key: 'recordid',
        slots: { title: 'recordid' },
        scopedSlots: { customRender: 'operate' }
      }
    ],
    listData: [],
    listDataLoading: false,
    recordListDataLoading: false,
    sendListData: [],
    webhookDetail: {},
    webhookDetailIsReady: true,
    submitting: false,
    isTestValid: false,
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      total: 0
    },
    statusType: [
      '失败',
      i18n.t('message["107"]')
    ],
    typeName: [
      i18n.t('message["1660"]'),
      '企微机器人',
      '钉钉机器人',
      '智能音箱'
    ],
    eventColumns: [
      {
        title: '事件',
        dataIndex: 'typename',
        key: 'typename',
        slots: { title: 'event' },
        scopedSlots: { customRender: 'event' },
        width: '60%'
      },
      {
        title: '推送数据格式',
        dataIndex: 'data',
        key: 'data',
        slots: { title: 'jsondata' },
        scopedSlots: {
          customRender: 'jsondata'
        }
      }
    ],
    eventListData: [
    ],
    jsonDatas: [],
    sendRangeData: [],
    sendRangeCheckedData: []
  },
  mutations: {
    setPageTotal (state, data) {
      state.pagination.total = data
      // state.pagination.currentPage = 1
    },
    setListData (state, data) {
      state.listData = data
    },
    setSendListData (state, data) {
      state.sendListData = data
    },
    setListDataLoading (state, b) {
      state.listDataLoading = b
    },
    setrecordListDataLoading (state, b) {
      state.recordListDataLoading = b
    },
    setwebhookDetail (state, data) {
      state.webhookDetail = data
    },
    setWebhookDetailIsReady (state, b) {
      state.webhookDetailIsReady = b
    },
    setEventListData (state, data) {
      state.eventListData = data
    },
    setSubmitting (state, b) {
      state.submitting = b
    },
    setJsonDatas (state, data) {
      state.jsonDatas = data
    },
    setIsTestValid (state, b) {
      state.isTestValid = b
    },
    // 设置推送数据范围data
    setSendRangeData (state, data) {
      state.sendRangeData = data
    },
    setSendRangeCheckedData (state, data) {
      state.sendRangeCheckedData = data
    }
  },
  getters: {
    jsonDataList (state) {
      const { jsonDatas } = state
      jsonDatas.forEach(item => {
        if (item.child && item.child.length > 0) {
          item['show'] = true
        }
      })
      return jsonDatas
    },
    webHookList (state) {
      const { listData } = state
      listData.forEach(item => {
        item.key = item.hookid
      })
      return listData
    },
    sendRecordList (state) {
      const { sendListData } = state
      sendListData.forEach(item => {
        item.key = item.recordid
      })
      return sendListData
    },
    currentRangeDatas (state) {
      const { sendRangeData = [] } = state
      function dataLoop (arr, pid) {
        arr.forEach((item, index) => {
          item.title = item.name

          item['pid'] = pid
          if (item.pid) {
            item.key = pid + '|' + item.keyname + '-' + item.id
          } else {
            item.key = item.keyname + '-' + item.id
          }
          if (item.children && item.children.length) {
            dataLoop(item.children, item.key)
          }
        })
      }
      dataLoop(sendRangeData, null)
      return sendRangeData || []
    }
  },
  actions: {
    async getWebhookList ({ commit }) {
      commit('setListDataLoading', true)
      const chain = await getWebhookList()
        .onSuccess((raw) => {
          commit('setListData', raw)
          commit('setListDataLoading', false)
        })
        .onNetComplete(() => {

        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    async DelWebhook ({ commit, dispatch }, data) {
      const chain = await DelWebhook()
        .params(data)
        .onSuccess(raw => {
          dispatch('getWebhookList')
        })
      return chain
    },
    async getWebhookRecordList ({ commit }, data) {
      commit('setrecordListDataLoading', true)
      const chain = await getWebhookRecordList()
        .params(data)
        .onSuccess((raw) => {
          commit('setSendListData', raw.list)
          commit('setPageTotal', raw.count)
          commit('setrecordListDataLoading', false)
        })
        .onNetComplete(() => {

        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    async getWebhookRecordDetail ({ commit }, data) {
      const chain = await getWebhookRecordDetail()
        .params(data)
        .onSuccess(raw => {
        })
      return chain
    },
    async sendRecordAgain ({ commit, dispatch }, data) {
      const chain = await sendRecordAgain()
        .params({ recordid: data.recordid })
        .onSuccess(raw => {
          dispatch('getWebhookRecordList', { hookid: data.hookid })
        })
      return chain
    },
    async getWebhookDetail ({ commit, state }, data) {
      const type = data.type
      if (!type) {
        commit('setWebhookDetailIsReady', false)
      }

      const chain = await getWebhookDetail()
        .params(data)
        .onSuccess(raw => {
          raw.webhook_event.forEach(item => {
            item.key = item.type
          })
          if (!data.type) {
            commit('setwebhookDetail', raw)
            commit('setWebhookDetailIsReady', true)
          }
          commit('setEventListData', raw.webhook_event)
        })
      return chain
    },
    async addEditWebhook ({ commit, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await addEditWebhook()
        .params(data)
        .onSuccess(async () => {})
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    async getInitJsonData ({ commit, state }, data) {
      const chain = await getInitJsonData()
        .params(data)
        .onSuccess(raw => {
        })
      return chain
    },
    async getVarData ({ commit, state }, data) {
      const chain = await getVarData()
        .params(data)
        .onSuccess(raw => {
          if (raw.length > 0) {
            raw.forEach(item => {
              if (item.child && item.child.length > 0) {
                item['show'] = true
                item.child.forEach(item2 => {
                  if (item2.tips && Object.keys(item2.tips).length > 0) {
                    item2.isArgShow = false
                  }
                })
              } else {
                if (item.tips && Object.keys(item.tips).length > 0) {
                  item.isArgShow = false
                }
              }
            })
          }
          commit('setJsonDatas', raw)
        })
        .fetch()
      return chain
    },
    async validForm ({ commit, dispatch }, data) {
      commit('setIsTestValid', true)
      const chain = await validForm()
        .params(data)
        .onSuccess(async () => {
        })
        .onNetComplete(() => {
          commit('setIsTestValid', false)
        })
        .config({ tip: false })
      return chain
    },
    async setStopUsing ({ commit, dispatch }, data) {
      const chain = await setStopUsing()
        .params(data)
        .onSuccess(raw => {
          dispatch('getWebhookList')
        })
        .fetch()
      return chain
    },

    // 获取团队树形结构
    async getRangeTreeDatas ({ commit, state }, data) {
      const chain = await getRelateDevpDatas()
        .params(data)
        .onSuccess(raw => {
          commit('setSendRangeData', raw)
        })
      return chain
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }
  }
}
